import 'vanilla-match-height';

// Uses https://github.com/mitera/vanilla-match-height

document.fonts.ready.then(() => { // wait for fonts to load

	let scrollY = 0; // prevents page from jumping

	const options = {
		beforeUpdate: () => {
			scrollY = window.scrollY;
		},
		afterUpdate: () => {
			window.scrollTo({ top: scrollY });
		}
	};

	document.body.matchHeight({elements: '.match-height-1', ...options});
	document.body.matchHeight({elements: '.match-height-2', ...options});
	document.body.matchHeight({elements: '.match-height-3', ...options});
	document.body.matchHeight({elements: '.match-height-4', ...options});

});